import axios from 'axios'

const http = axios.create({
  baseURL: '/api',
  timeout: 20000,
})

function unwrap(res) {
  const body = res.data
  if (!body?.ok) {
    throw new Error(body?.message || '接口调用失败')
  }
  return body.data
}

export async function fetchConfig() {
  const res = await http.get('/config')
  return unwrap(res)
}

/** @param {string} url 当前页面完整 URL（不含 hash） */
export async function fetchJsSignature(url) {
  const res = await http.get('/js-signature', { params: { url } })
  return unwrap(res)
}

export async function fetchGroupChatList({ cursor = '', owners = [], limit = 50 } = {}) {
  const res = await http.get('/groupchats', {
    params: {
      cursor,
      limit,
      owners: owners.join(','),
    },
  })
  return unwrap(res)
}

export async function fetchGroupChatDetail(chatId) {
  const res = await http.get(`/groupchats/${encodeURIComponent(chatId)}`)
  return unwrap(res)
}
